import React from 'react';
import { Grid } from '@mui/material';
import { Control, UseFormSetValue } from 'react-hook-form';
import FormField from './FormField';
import { FormFieldSchema, FormSchema } from './types';

interface FormRendererProps {
  schema: FormSchema;
  control: Control<any>;
  handleFileUpload?: (file: File, uploadFor: string) => Promise<string>;
  userRole?: string;
  setValue?: UseFormSetValue<any>;
}

const FormRenderer = ({
  schema,
  control,
  handleFileUpload,
  userRole,
  setValue
}: FormRendererProps) => {
  return (
    <Grid container spacing={2}>
      {schema.map((field: FormFieldSchema, fieldIndex: number) => {
        if (field.type === 'section') {
          return field.children.map((childField, childIndex) => (
            <FormField
              key={`${field.name}-${childField.name}-${childIndex}`}
              field={childField}
              control={control}
              handleFileUpload={handleFileUpload}
              userRole={userRole}
              setValue={setValue}
            />
          ));
        }
        return (
          <FormField
            key={`${field.name}-${fieldIndex}`}
            field={field}
            control={control}
            handleFileUpload={handleFileUpload}
            userRole={userRole}
            setValue={setValue}
          />
        );
      })}
    </Grid>
  );
};

export default FormRenderer;
